<template>
  <div>
    <div class="main">
      <el-form ref="form" :model="form" label-width="160px" :rules="rules">
        <div class="title">Please set password</div>
        <el-form-item label="Email">
          <el-input v-model="userdetail.mail" disabled></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="Password">
          <el-input v-model="form.Password" show-password></el-input>
        </el-form-item>
        <el-form-item label="Confirm Password" prop="Confirm">
          <el-input v-model="form.Confirm" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setQuotationInfo()">Submit</el-button>
        </el-form-item>
      </el-form>

    </div>
  </div>
</template>

<script>
import { setQuotationInfo, getEQuoteUserDetail, advertisementFlow } from "@/api/api";
export default {
  data() {
    const comfirm = (rule, value, callback) => {
      if (value != this.form.Password) {
        callback(new Error("The two passwords are inconsistent!"));
      } else {
        callback();
      }
    };
    return {
      form: {},
      userdetail: [],
      rules: {
        Password: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        Confirm: [
          { required: true, message: "Please complete this required field", trigger: "blur" },
          { validator: comfirm, trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getEQuoteUserDetail();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "setPassword",
          source: "",
          information: "设置密码页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
            // console.log(source);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "setPassword",
          source: this.$route.query.source,
          information: "设置密码页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
            // console.log(source);
          }
        });
      }
    },
    // 获取详情
    getEQuoteUserDetail() {
      getEQuoteUserDetail({
        id: this.$route.query.id
      }).then(res => {
        this.userdetail = res.data;
      });
    },
    setQuotationInfo() {
      this.$refs.form.validate(valid => {
        if (valid) {
          setQuotationInfo({
            id: this.$route.query.id,
            mail: this.userdetail.mail,
            password: this.form.Password,
            passwordConfirm: this.form.Confirm,
            code: this.$route.query.code
          }).then(res => {
            this.$router.push({ name: "equote", query: { source: "setpassword" } });
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  // display: flex;
  // justify-content: center;
}
.el-form {
  width: 700px;
  border: 1px solid rgb(230, 226, 226);
  padding: 50px;
  border-radius: 10px;
  margin: 50px auto;
  box-shadow: 2px 2px 20px 2px rgb(230, 226, 226);
  .title {
    font-size: 25px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 20px;
  }
  /deep/.el-form-item__error {
    font-size: 12px !important;
  }
}
</style>